import { useEffect, useState } from "react";

// In GroupEditModal.js
const GroupEditModal = ({ group, onClose, onSave }) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  const [errors, setErrors] = useState({ title: "", description: "" });

  useEffect(() => {
    if (group) {
      setTitle(group.metadata?.groupName || "");
      setDescription(group.metadata?.groupDescription || "");
      setErrors({ title: "", description: "" });
    }
  }, [group]);

  const handleTitleChange = (e) => {
    setTitle(e.target.value);
    if (e.target.value.trim() !== "") {
      setErrors((prev) => ({ ...prev, title: "" }));
    }
  };

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
    if (e.target.value.trim() !== "") {
      setErrors((prev) => ({ ...prev, description: "" }));
    }
  };

  const handleSave = () => {
    let valid = true;
    let newErrors = { title: "", description: "" };

    if (!title.trim()) {
      newErrors.title = "Title cannot be empty";
      valid = false;
    }
    if (!description.trim()) {
      newErrors.description = "Description cannot be empty";
      valid = false;
    }

    setErrors(newErrors);

    if (!valid) return;

    onSave({
      id: group.id,
      name: title,
      description: description,
    });

    setTitle("");
    setDescription("");
    onClose();
  };

  return (
    <div
      className="modal-overlay"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1050,
      }}
    >
      <div
        className="modal-content"
        style={{
          backgroundColor: "#132534",
          padding: "20px",
          borderRadius: "8px",
          width: "500px",
          maxWidth: "90%",
        }}
      >
        <div className="modal-header mb-4 d-flex justify-content-center align-items-center position-relative">
          <h1 className="text-white modal-title text-heading-chat-modal new-message-heading">
            Edit Group
          </h1>
          <button
            type="button"
            className="btn-close btn-close-white position-absolute end-0 me-3"
            onClick={onClose}
            aria-label="Close"
            style={{
              background: "transparent",
              border: "none",
              fontSize: "1.5rem",
              cursor: "pointer",
            }}
          ></button>
        </div>
        <div className="modal-body">
          <div className="row gap-4">
            <div className="col-md-12">
              <div className="textfield-1">
                <input
                  type="text"
                  className="text-body-b2"
                  placeholder=" Title"
                  value={title}
                  onChange={handleTitleChange}
                  style={{
                    width: "100%",
                    padding: "10px",
                    backgroundColor: "transparent",
                    border: "1px solid #1b2c3a",
                    color: "white",
                  }}
                />
                <label
                  className="text-body-b2"
                  style={{ backgroundColor: "#132534" }}
                >
                  Title
                </label>

                {/* error msg  */}
                {errors.title && (
                  <div
                    style={{
                      color: "#eb5757",
                      fontSize: "0.85rem",
                      marginTop: "4px",
                      marginLeft: "4px",
                    }}
                  >
                    {errors.title}
                  </div>
                )}
              </div>
            </div>

            <div className="col-md-12">
              <div className="textfield-1">
                <textarea
                  className="text-body-b2"
                  placeholder=" Description"
                  value={description}
                  onChange={handleDescriptionChange}
                  style={{
                    width: "100%",
                    padding: "10px",
                    backgroundColor: "transparent",
                    border: "1px solid #1b2c3a",
                    color: "white",
                    minHeight: "100px",
                  }}
                />
                <label
                  className="text-body-b2"
                  style={{ backgroundColor: "#132534" }}
                >
                  Description
                </label>

                {/* error msg  */}
                {errors.description && (
                  <div
                    style={{
                      color: "#eb5757",
                      fontSize: "0.85rem",
                      marginTop: "4px",
                      marginLeft: "4px",
                    }}
                  >
                    {errors.description}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="d-flex gap-3 mt-4 justify-content-center">
            <button
              className="btn-1 btn-1-primary px-3"
              style={{ width: "182px" }}
              onClick={handleSave}
            >
              Save
            </button>
            <button
              className="btn-1 btn-1-primary px-3"
              style={{ width: "182px", backgroundColor: "#eb5757" }}
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupEditModal;
